<script lang="ts">
    import Profile from './Profile.svelte';
    import Alert from '../../lib/Alert.svelte';
    import * as t from '../../translations/Directory.ts';
    
    export let params;
    export let getPreviousRoute;
    
</script>

<Alert type="success" class="col-start-2 col-span-4">
    {t.Compose_Message_Confirmation_Message_1()}
    {t.Compose_Message_Confirmation_Message_2()}
</Alert>

<Profile {params}
         {getPreviousRoute}
/>